<template>
    <button
        :data-element="checkDataElement(dataElement)"
        type="button"
        :class="classes"
        :disabled="disabled"
        @click="click"
    >{{ title }}
    </button>
</template>

<script>
/* global Mango */
export default {
    name: 'Button',
    props: {
        dataElement: String,
        title: String,
        size: String,
        color: String,
        outline: Boolean,
        link: Boolean,
        rounded: Boolean,
        block: Boolean,
        loading: Boolean,
        disabled: Boolean,
        defaultClass: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        classes() {
            let classes = ['btn'];

            if (!this.defaultClass) {
                classes = [];
            }

            if (this.size) {
                classes.push(this.size);
            }

            if (this.color) {
                classes.push(this.color);
            }

            if (this.outline) {
                classes.push('outline');
            }

            if (this.link) {
                classes.push('link');
            }

            if (this.rounded) {
                classes.push('rnd');
            }

            if (this.block) {
                classes.push('block');
            }

            if (this.loading) {
                classes.push('btn-wait');
            }

            return classes;
        }
    },
    methods: {
        click(event) {
            if (!this.loading) {
                this.$emit('click', event)
            }
        },
        checkDataElement(id) {
            return Mango.checkDataElement(id);
        }
    }
}
</script>